import { has } from "lodash";
import { isValidPhoneNumber } from "react-phone-number-input";
import validator from "validator";

import { translate } from "src/services";

const numberRegex = /^\d+$/;

export const isEmail = (value: string) => {
  return value
    ? validator.isEmail(value)
      ? undefined
      : translate("validationMessages.isEmail")
    : undefined;
};

export const isIntlPhone = (value: string) =>
  value && value.length > 2
    ? isValidPhoneNumber(value)
      ? undefined
      : translate("validationMessages.isPhone")
    : undefined;

export const isRequired = (value: any) =>
  value ? undefined : translate("validationMessages.isRequired");

export const isRequiredNumber = (value?: number | null) => {
  if (value === undefined || value === null) {
    return translate("validationMessages.isRequired");
  }
};
export const isNumber = (value: string) =>
  value && numberRegex.test(value) ? undefined : translate("validationMessages.isNumber");

export const hasCoordinates = (value: any) => {
  if (value) {
    return has(value, "latitude") && value.longitude && has(value, "longitude") && value.latitude
      ? undefined
      : translate("validationMessages.hasCoordinates");
  }

  return undefined;
};

export const hasCountry = (value: any) => {
  if (value) {
    return has(value, "country") && value.country
      ? undefined
      : translate("validationMessages.hasCountry");
  }

  return undefined;
};

export const hasStreetAndNumber = (value: any) =>
  has(value, "streetAndNumber") && value.streetAndNumber
    ? undefined
    : translate("validationMessages.hasStreetAndNumber");

export const hasCity = (value: any) => {
  if (value) {
    return has(value, "city") && value.city ? undefined : translate("validationMessages.hasCity");
  }

  return undefined;
};

export const hasStreet = (value: any) => {
  if (value) {
    return has(value, "street") && value.street
      ? undefined
      : translate("validationMessages.hasStreet");
  }

  return undefined;
};

export const hasStreetNumber = (value: any) => {
  if (value) {
    return has(value, "streetNumber") && value.streetNumber
      ? undefined
      : translate("validationMessages.hasStreetNumber");
  }

  return undefined;
};

export const hasZip = (value: any) => {
  if (value) {
    return has(value, "zip") && value.zip ? undefined : translate("validationMessages.hasZip");
  }

  return undefined;
};
